import { applyTextDiff, updateBlockProps } from "@worktools/shared";
import { useBlockProps, useYText } from "../../sync/hooks";
import { useBoard } from "../../sync/BoardContext";

const TONES: Record<string, string> = {
  yellow: "#fdf3d0",
  mint: "#dceee9",
  rose: "#f6dde3",
  sky: "#dde5f4",
  paper: "#f4f3f0",
};

export function NoteBlock({ blockId }: { blockId: string }) {
  const { doc } = useBoard();
  const props = useBlockProps<{ tone: string }>(blockId);
  const { text, value } = useYText(blockId, "text");
  const tone = TONES[props.tone] ?? TONES.yellow;

  return (
    <div style={{ position: "absolute", inset: 0, background: tone, display: "flex", flexDirection: "column" }}>
      <textarea
        value={value}
        placeholder="Notiz…"
        onChange={(event) => text && applyTextDiff(text, event.target.value)}
        style={{
          flex: 1,
          border: "none",
          background: "none",
          resize: "none",
          padding: 14,
          fontSize: 14,
          lineHeight: 1.5,
          outline: "none",
        }}
      />
      <div style={{ display: "flex", gap: 5, padding: "0 12px 10px" }}>
        {Object.entries(TONES).map(([name, color]) => (
          <button
            key={name}
            onClick={() => updateBlockProps(doc, blockId, { tone: name })}
            className={`swatch${props.tone === name ? " swatch--active" : ""}`}
            style={{ background: color }}
            title={name}
          />
        ))}
      </div>
    </div>
  );
}
